<template>
  <div>
    <nav
      v-if="totalPaginas > 1"
    >
      <ul class="pagination flex justify-content-center">
        <li class="page-item" :class="{ disabled: pagina == 1 }">
          <a class="page-link" href="#" aria-label="Previous" @click="alterarPagina(pagina - 1)">
            <span aria-hidden="true">&laquo;</span>
          </a>
        </li>

        <li
          v-for="indexPagina in Math.min(10, totalPaginas)"
          :key="indexPagina"
          class="page-item"
          :class="{ active: pagina == indexPagina + pagina - indiceCalculoPagina }"
        >
          <a v-if="indexPagina + pagina - indiceCalculoPagina<=totalPaginas" class="page-link" href="#" @click="alterarPagina(indexPagina + pagina - indiceCalculoPagina)">
            {{
            indexPagina + pagina - indiceCalculoPagina
            }}
          </a>
        </li>
        <li
          class="page-item"
          :class="{ disabled: pagina == totalPaginas}"
        >
          <a class="page-link" href="#" aria-label="Next" @click="alterarPagina(pagina + 1)">
            <span aria-hidden="true">&raquo;</span>
          </a>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  name: "Paginacao",
  components: {},
  props: {
    total: { type: Number, default: 0 },
    limit: { type: Number, default: 1 }
  },
  computed:{
    totalPaginas: function()
    {
      return (this.total % this.limit == 0 ? Math.floor(this.total / this.limit) : Math.floor(this.total / this.limit) + 1 );
    },
    indiceCalculoPagina: function()
    {

      return Math.max(1,(this.pagina > 4 ? 4 : this.pagina));
      
    }
  },
  methods: {
    alterarPagina(novaPagina) {
      this.pagina = novaPagina;
      this.$emit("change-pagina");
    }
  },
  data: function() {
    return {
      pagina: 1
    };
  }
};
</script>

<style></style>
